import { Typography, Stack, styled } from '@mui/material';

export const Container = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledDescription = styled(Typography)(() => ({
  fontSize: 12,
}));
